"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var REGIONS = {
  northAmerica: 'NA',
  latinAmerica: 'LA',
  emea: 'EMEA',
  asia: 'APA'
};
var _default = exports.default = REGIONS;